import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ArtworkPriceTracker } from './components/ArtworkPriceTracker';
import { ViewArtwork } from './pages/ViewArtwork';
import { Layout } from './components/Layout';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Layout data-id="element-3">
              <ArtworkPriceTracker data-id="element-4" />
            </Layout>} data-id="element-2" />
        <Route path="/view/:artworkName" element={<ViewArtwork data-id="element-6" />} data-id="element-5" />
      </Routes>
    </BrowserRouter>;
}